'use strict';

// FIXME: This blows up the unit tests.
// import appStore from './AppStore';

//==================================================================
// Utility functions to deal with exception while parsing JSON
//===================================================================

/**
 * Given a Json object, returns a parsed Json or a null if not parsed.
 */
export const parseJson = (jsonObject) => {
    let parsedJson = null;
    try {
        parsedJson = JSON.parse(jsonObject);
    } catch(e) {
        const objString = JSON.stringify(jsonObject);
        console.error(`Could not parse JSON [${objString}]`);
        //appStore.getLogger().error(`Could not parse JSON [${objString}]`);
    }
    return parsedJson;
};

/**
 * Tests if a string is a JSON object. Returns true if so. Otherwise, false.
 * @param string
 * @returns {boolean}
 */
export const isJsonString = (string) => {
    try {
        JSON.parse(string);
    } catch (e) {
        return false;
    }
    return true;
}